import { SelectOption } from 'components/Inputs/DropdownChecbox/DropdownCheckbox';

export const upload_schedule: SelectOption[] = [
	{ label: 'Same Day', value: 'SAME' },
	{ label: 'Next Day', value: 'NEXT' },
];
